import {
  Col,
  Flex,
  Form,
  Row,
  Select,
  Switch,
  Typography,
  Tooltip,
  Tag,
} from "antd";
import { CustomFieldConfig } from "./types";
import { TicketData } from "../../models/event";

const { Text } = Typography;

export const renderField = (
  field: CustomFieldConfig,
  sectionId: string,
  fieldIndex: number,
  tickets: TicketData[],
  parentControlled = false,
  sectionEnabled = true,
) => {
  return (
    <Form.Item noStyle shouldUpdate key={`${sectionId}-${fieldIndex}`}>
      {({ getFieldValue }) => {
        const isEnabled = parentControlled
          ? sectionEnabled
          : getFieldValue([sectionId, "fields", fieldIndex, "enabled"]);

        const isRequired = parentControlled
          ? (getFieldValue([sectionId, "is_required"]) ?? false) ||
            !!field.fixedRequired
          : (getFieldValue([sectionId, "fields", fieldIndex, "is_required"]) ??
            field.required);

        if (parentControlled) {
          return (
            <div
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: "10px 12px",
                background: isEnabled ? "#fff" : "#fafafa",
                transition: "0.2s",
              }}
            >
              <Flex align="center" gap={8} wrap="wrap">
                <Text
                  strong
                  style={{
                    fontSize: 13,
                    color: isEnabled ? "#262626" : "#a3a3a3",
                  }}
                >
                  {field.label}
                </Text>

                {!isEnabled && (
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Disabled
                  </Text>
                )}
              </Flex>
            </div>
          );
        }

        return (
          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: 8,
              padding: "10px 12px",
              background: isEnabled ? "#fff" : "#fafafa",
              transition: "0.2s",
            }}
          >
            <Row gutter={[12, 10]} align="middle">
              <Col xs={24} md={10}>
                <Flex align="center" gap={8} wrap="wrap">
                  <Text
                    strong
                    style={{
                      fontSize: 13,
                      color: isEnabled ? "#262626" : "#a3a3a3",
                    }}
                  >
                    {field.label}
                  </Text>

                  {field.fixedRequired && (
                    <Tag
                      color="red"
                      style={{
                        margin: 0,
                        fontSize: 10,
                        lineHeight: "18px",
                        paddingInline: 6,
                      }}
                    >
                      Mandatory
                    </Tag>
                  )}

                  {!field.fixedRequired && isRequired && isEnabled && (
                    <Tag
                      color="red"
                      style={{
                        margin: 0,
                        fontSize: 10,
                        lineHeight: "18px",
                        paddingInline: 6,
                      }}
                    >
                      Required
                    </Tag>
                  )}
                </Flex>
              </Col>

              <Col xs={24} md={12}>
                {isEnabled ? (
                  <Flex gap={10} align="center" wrap="wrap">
                    <Tooltip title="Required field">
                      <Flex align="center" gap={6}>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          Required
                        </Text>

                        <Form.Item
                          name={[
                            sectionId,
                            "fields",
                            fieldIndex,
                            "is_required",
                          ]}
                          valuePropName="checked"
                          noStyle
                        >
                          {!field.fixedRequired && (
                            <Switch
                              size="small"
                              disabled={field.fixedRequired}
                            />
                          )}
                        </Form.Item>
                      </Flex>
                    </Tooltip>

                    {!field.fixedEnabled ? (
                      <Form.Item
                        name={[
                          sectionId,
                          "fields",
                          fieldIndex,
                          "enabled_for_categories",
                        ]}
                        rules={[
                          {
                            required: true,
                            message: "Please select at least one ticket",
                          },
                        ]}
                        noStyle
                      >
                        <Select
                          mode="multiple"
                          size="small"
                          placeholder="Tickets"
                          maxTagCount="responsive"
                          style={{ minWidth: 180 }}
                          options={tickets.map((ticket) => ({
                            label: ticket.name,
                            value: ticket.id ?? ticket.name,
                          }))}
                        />
                      </Form.Item>
                    ) : (
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        All tickets
                      </Text>
                    )}
                  </Flex>
                ) : (
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Disabled
                  </Text>
                )}
              </Col>

              <Col xs={24} md={2}>
                <Flex justify="end">
                  <Form.Item
                    name={[sectionId, "fields", fieldIndex, "enabled"]}
                    valuePropName="checked"
                    noStyle
                  >
                    {!field.fixedRequired && (
                      <Switch
                        size="small"
                        disabled={field.fixedRequired || field.fixedEnabled}
                      />
                    )}
                  </Form.Item>
                </Flex>
              </Col>
            </Row>
          </div>
        );
      }}
    </Form.Item>
  );
};
